const LtiRequestType = {
  RESOURCE_LINK: 'LtiResourceLinkRequest',
  DEEP_LINKING: 'LtiDeepLinkingRequest',
};

export default LtiRequestType;
